import React, { useState } from 'react';
import { motion } from 'framer-motion';
import './SkillVisualization.css';

const SkillVisualization = ({ skills, title }) => {
  const [hoveredSkill, setHoveredSkill] = useState(null);

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        type: "spring",
        stiffness: 300,
        damping: 24
      }
    }
  };

  return (
    <div className="skill-visualization">
      <motion.h3 
        className="skill-category-title"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        {title}
      </motion.h3>
      <motion.div 
        className="skills-container"
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        {skills.map((skill, index) => (
          <motion.div
            key={index}
            className="skill-item"
            variants={itemVariants}
            whileHover={{ scale: 1.05, rotateY: 5 }}
            onHoverStart={() => setHoveredSkill(index)}
            onHoverEnd={() => setHoveredSkill(null)}
          >
            <div className="skill-card">
              <motion.div 
                className="skill-icon"
                animate={{ 
                  rotateY: hoveredSkill === index ? 360 : 0,
                  scale: hoveredSkill === index ? 1.1 : 1
                }}
                transition={{ duration: 0.6 }}
              >
                <i className={skill.icon}></i>
              </motion.div>
              <motion.h4 
                className="skill-name"
                animate={{ 
                  color: hoveredSkill === index ? '#BD5D38' : '#45a29e'
                }}
                transition={{ duration: 0.3 }}
              >
                {skill.name}
              </motion.h4>
              {skill.level && (
                <div className="skill-level">
                  <div className="skill-level-bar">
                    <motion.div 
                      className="skill-level-fill"
                      initial={{ width: 0 }}
                      animate={{ width: `${skill.level}%` }}
                      transition={{ duration: 1.5, delay: index * 0.1 }}
                    />
                  </div>
                  <span className="skill-percentage">{skill.level}%</span>
                </div>
              )}
            </div>
          </motion.div>
        ))}
      </motion.div>
    </div>
  );
};

export default SkillVisualization;
